import { render, staticRenderFns } from "./newpreview.vue?vue&type=template&id=51dcb481&scoped=true"
import script from "./newpreview.vue?vue&type=script&lang=js"
export * from "./newpreview.vue?vue&type=script&lang=js"
import style0 from "./newpreview.vue?vue&type=style&index=0&id=51dcb481&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51dcb481",
  null
  
)

export default component.exports